import React from 'react';
import PortfolioList from '../../components/Portfolios/PortfolioList';

const Portfolios = () => {
  return (
    <div className="page-container">
      <PortfolioList />
    </div>
  );
};

export default Portfolios;

